import React, { useState, useEffect } from "react";

export default function ImageGeneration() {
  const images = [
    `${process.env.PUBLIC_URL}/Car.png`,
    `${process.env.PUBLIC_URL}/Car2.png`,
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      className="min-h-screen flex flex-col bg-gray-900 text-white px-2 md:px-8 pt-20"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/AI.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex-grow flex md:flex-row items-stretch justify-center gap-12 px-8 pt-20 mb-20">
        {/* Left: Image */}
        <div className="w-full md:w-1/2 hidden md:flex justify-center items-stretch">
          <img
            src={images[currentImage]}
            alt="AI Generated Art"
            className="w-full h-full rounded-2xl shadow-lg object-cover transition duration-1000"
          />
        </div>

        {/* Right: Text */}
        <div className="bg-black/60 backdrop-blur-md p-8 rounded-2xl shadow-lg w-auto flex flex-col justify-center">
          <h1 className="text-4xl font-bold text-purple-400 mb-6">Image Generation</h1>

          <p className="text-gray-300 leading-relaxed text-lg mb-6">
            Built an AI-based image generation system using Generative Adversarial Networks (GANs) to create realistic images.
          </p>

          <ul className="list-disc list-outside pl-6 text-gray-300 leading-relaxed text-md md:text-lg space-y-4">
            <li><strong>Model Development:</strong> Designed and trained GAN models using TensorFlow and Keras for high-fidelity image generation.</li>
            <li><strong>Training:</strong> Applied advanced techniques such as feature matching and progressive growing to improve output quality.</li>
            <li><strong>Optimization:</strong> Tuned hyperparameters and loss functions to stabilize GAN training and avoid mode collapse.</li>
            <li><strong>Visualization:</strong> Produced visually compelling synthetic images, demonstrating creative AI capabilities.</li>
          </ul>

          <p className="text-gray-300 leading-relaxed text-lg mt-6">
            Successfully generated high-quality images, showcasing advanced AI creativity and modeling skills.
          </p>
        </div>
      </div>
    </div>
  );
}
